import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearDeleteGroup } from "../deleteModalSlice";
import { IInitialSliceState } from "../../../common/types/commonTypes";

interface IDeleteGroupResponseState {
    deleteModal: IInitialSliceState;
  }

const useNoActionPopup = () => {
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState("");
    const dispatch: any = useDispatch();

    const deleteGroupResponseMsg = useSelector((state: IDeleteGroupResponseState) => state.deleteModal.msg);
    useEffect(() => {
      if (deleteGroupResponseMsg?.includes("group cannot be deleted")) {
        setShow(true);
        setMessage(deleteGroupResponseMsg);
        dispatch(clearDeleteGroup());
      }
    }, [deleteGroupResponseMsg]);
  
    const handleClose = () => {
      setShow(false);
      setMessage("");
    };

  return { handleClose, show, message };
};

export default useNoActionPopup;
